<template>
  <div class="filter-item-wrapper">
    <label
      :for="'input_' + identifier"
      class="label"
      v-html="label"
      :title="title || label"
    />
    <NumericInput
      :placeholder="$tv('from', 'categories')"
      v-model="fromVal"
      :format="getFormat"
      :disabled="disabled"
      :id="'input_' + identifier"
    />
    <DropDown
      :data-items="toleranceDropdown"
      :disabled="!(this.fromVal && !isNaN(this.fromVal))"
      @change="changeTolerance($event)"
      :text-field="'tolerance'"
      :data-item-key="'value'"
      :value-field="'value'"
      :value="selectedValues.tolerance"
      :value-primitive="true"
      v-model="toleranceDisplay"
      :id="'input_' + identifier"
      class="tolerance-dropdown"
    />
  </div>
</template>

<script>
import {VALUE_TYPES} from '~/assets/js/filters'
import NumericInput from '~/components/input-components/NumericInput'
import DropDown from '~/components/input-components/DropDown'
import {TOLERANCE_SET} from '~/assets/js/constants'

export default {
  name: 'AttributeFilterRange',
  components: {
    NumericInput,
    DropDown
  },
  props: {
    format: {
      type: String,
      required: true,
      default () {
        return ''
      }
    },
    label: {
      type: String,
      required: true,
      default () {
        return ''
      }
    },
    title: {
      type: String,
      required: false,
      default () {
        return null
      }
    },
    identifier: {
      type: Number,
      required: true,
      default () {
        return 0
      }
    },
    filterValues: {
      type: Array || null,
      required: true,
      default() {
        return []
      }
    },
    selectedValues: {
      type: Object || null,
      required: true,
      default() {
        return null
      }
    },
    disabled: {
      type: Boolean,
      default() {
        return false
      }
    },
    localizedMeasure: {
      type: [String, Object],
      default() {
        return null
      }
    }
  },
  data() {
    return {
      fromValMM: undefined,
      fromValInch: undefined,
      toleranceDisplay: null,
      toleranceVal: null
    }
  },
  computed: {
    getFormat() {
      if (this.format === VALUE_TYPES.FLOAT || this.format === VALUE_TYPES.MULTI_DOUBLE) {
        return this.localizedMeasure === 'inch' ? 'n3' : 'n2'
      }
      else {
        return 'n0'
      }
    },
    fromVal: {
      get() {
        if (this.localizedMeasure === 'inch') {
          return this.fromValInch
        } else {
          return this.fromValMM
        }
      },
      set(val) {
        this.setFromValue(val)
        this.$emit('input-value', {from: this.validateInput(this.fromValMM), tolerance: this.selectedValues.tolerance})
      }
    },
    toleranceDropdown() {
      if (this.fromVal && !isNaN(this.fromVal)) {
        let tolerances = TOLERANCE_SET.ToleranceArray
        return tolerances.map(tolerance => {
          return {
            tolerance: '+/- ' + (this.fromVal * tolerance.value / 100).toFixed(this.localizedMeasure === 'inch' ? 3 : 2),
            value: tolerance.value
          }
        })
      }
      return [{tolerance: this.localizedMeasure === 'inch' ? '+/- 0.000' : '+/- 0.00', value: 0}]
    }
  },
  watch: {
    selectedValues: {
      deep: true,
      immediate: true,
      handler() {
        this.fromValMM = this.selectedValues.from
        if (this.selectedValues.from) {
          this.fromValInch = parseFloat((this.selectedValues.from / 25.4).toFixed(4))
        } else {
          this.fromValInch = this.selectedValues.from
        }
        if (!this.fromVal) {
          this.toleranceDisplay = null
        }
      }
    }
  },
  methods: {
    setFromValue(val) {
      this.fromValInch = val
      this.fromValMM = val
      if (val && this.localizedMeasure === 'inch') {
        this.fromValMM = parseFloat((val * 25.4).toFixed(4))
      } else if (val && this.localizedMeasure === 'mm') {
        this.fromValInch = parseFloat((val / 25.4).toFixed(2))
      }
    },
    validateInput(value) {
      const val = parseFloat(value)
      if (!Number.isNaN(val))
      {
        return val
      }
      else {
        return null
      }
    },
    changeTolerance(event) {
      this.toleranceDisplay = event.target.value
      this.toleranceVal = event.value
      this.$emit('input-value', {from: this.selectedValues.from, tolerance: this.toleranceVal})
    }
  }
}
</script>

<style lang="scss">
.filter-item-wrapper {
  .form__numericInput {
    width: calc(50% - .3125rem);
  }

  .tolerance-dropdown {
    width: calc(50% - .3125rem);
    padding: 0;
    font-weight: 500;
    font-size: .875rem;
  }
}
</style>
